import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root',
})
export class CommonApiService {
  constructor(private http: HttpService) { }

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/common' + path, queryMap);
  }


  joinEmailList({ email }: { email: string }): Promise<boolean> {
    const url = this.buildurl('/join/email');
    const body = { email };
    return this.http.post(url, body);
  }
}
